/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-contact-form block)");
/* eslint-enable no-console */
(() => {
    const contactForm = document.querySelector("#contactForm")
    const submitUrl = window.location.origin.includes('localhost')
        ? `${window.location.origin}/ultimetheme/wp-json/ultime-blocks/v1/contactFormSubmit`
        : `${window.location.origin}/wp-json/ultime-blocks/v1/contactFormSubmit`

    contactForm.addEventListener("submit", async (event) => {
        event.preventDefault()
        const infoMsg = contactForm.querySelector("#infoMsg")
        const successMsg = contactForm.querySelector("#successMsg")
        const submitButton = contactForm.querySelector('#submitBtn')
        infoMsg.textContent = ""
        successMsg.textContent = ""
        submitButton.disabled = true

        const formData = new FormData(contactForm)
        const errors = contactForm.querySelectorAll(".error-msg")
        errors.forEach((element) => {
            element.textContent = ""
        })
        const response = await (await fetch(submitUrl, {
            method: "POST",
            body: formData
        })).json()
        if (response.success === false) {
            if (response.msg) {
                infoMsg.textContent = response.msg
                submitButton.disabled = false
                return
            }

            const { errors } = response
            errors.forEach((element) => {
                // console.log('TEST', document.querySelector(`#${element.type}Error`))
                document.querySelector(`#${element.type}Error`).textContent = element.msg
            })
            submitButton.disabled = false
        }

        if (response.success === true) {
            contactForm.reset()
            successMsg.textContent = response.msg
        }
    })
})()
